import React from 'react';
import { Icon, IconButton, Tooltip } from '@mui/material';

const ActDeleteUser = ({ userInfo, setUserInfo, setOpenDelete }) => {
  const handleOpenDialog = () => {
    setOpenDelete(true);
    setUserInfo(userInfo);
  };
  return (
    <>
      <Tooltip title="Vô hiệu hoá người dùng" placement="top">
        <IconButton className="button" aria-label="Xóa" onClick={handleOpenDialog}>
          <Icon>do_not_disturb</Icon>
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ActDeleteUser;
